import { Navigate } from "react-router-dom";
import { useAuth } from "../providers/AuthProvider";

// ─── Spinner shown while the auth state is being resolved ─────────────────────
function LoadingScreen() {
  return (
    <div style={{
      minHeight: "100vh",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      backgroundColor: "#1c3259",
    }}>
      <div className="spinner-border text-light" role="status" />
    </div>
  );
}

// ─── Requires a valid token + resolved user ────────────────────────────────────
export function PrivateRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading) return <LoadingScreen />;
  return user ? children : <Navigate to="/login" replace />;
}

// ─── Requires a specific role (e.g. "administrateur") ─────────────────────────
export function RoleRoute({ children, role }) {
  const { user, loading } = useAuth();
  if (loading) return <LoadingScreen />;
  if (!user) return <Navigate to="/login" replace />;
  if (user.role !== role) return <Navigate to="/dashboard" replace />;
  return children;
}
